import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { Bons, Tooltip } from 'react-wot-bootstrap'
import FamePoints from 'components/FamePoints/FamePoints'
import VehicleType from 'components/VehicleType/VehicleType'
import VehicleAddToComparison from 'components/VehicleAddToComparison/VehicleAddToComparison'
import { VEHICLE_TO_COMPARE_TOOLTIP } from 'components/VehicleAddToComparison/constants'
import { NO_DESCRIPTION_VEHICLES } from 'containers/WGCWXShop/products.config'
import Back from 'components/Back/Back'
import TankInfo from './components/TankInfo/TankInfo'
import Footer from './components/Footer/Footer'
import WGCWXRewardsTankConfirmation from './components/WGCWXRewardsTankConfirmation/WGCWXRewardsTankConfirmation'
import {
    RewardPropTypes,
    RewardsMetaPropTypes,
    BalancePropTypes,
} from 'containers/WGCWXShop/propTypes'
import { toRoman } from 'helpers'
import { isCnRealm } from 'containers/WGCWXShop/helpers'
import { KEY_CODES } from 'constants'

import styles from './WGCWXRewardsTank.scss'
import confirmationStyles from './components/WGCWXRewardsTankConfirmation/WGCWXRewardsTankConfirmation.scss'

import {
    AFFIRMATIVE_BUTTON,
    INFO_TEXT_STYLE,
    STYLE_VETERAN,
    CANCEL_BET,
    CANCEL_BET_TITLE,
    CANCEL_BET_DESCRIPTION,
    NO,
    PURCHASE_TANK,
    PURCHASE,
    CURRENCY_TO_SPEND,
    CURRENCY_LEFT,
} from './translations'

export class WGCWXRewardsTank extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tankPurchaseConfirmationOpened: false,
            cancelBetConfirmationOpened: false,
            bet: props.rewardsMeta.minBet,
            selectedTank: props.selectedTank[0],
            meta: props.rewardsMeta,
            anyTankSelected: props.anyTankSelected,
            oldCrystalBalance: props.accountBalance.crystal,
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyPress)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.accountBalance.crystal !== this.props.accountBalance.crystal) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                oldCrystalBalance: prevProps.accountBalance.crystal,
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyPress)
    }

    handleBackButtonClick = () => {
        this.props.backToRewardsHandler()
    }

    onClose = () => {
        this.props.backToRewardsHandler()
    }

    handleKeyPress = e => {
        if (e.keyCode !== KEY_CODES.ESCAPE) return
        if (this.state.tankPurchaseConfirmationOpened || this.state.cancelBetConfirmationOpened) return
        this.props.backToRewardsHandler()
    }

    openTankPurchaseConfirmation = () => {
        this.setState({ tankPurchaseConfirmationOpened: true })
    }

    closeTankPurchaseConfirmation = () => {
        this.setState({ tankPurchaseConfirmationOpened: false })
    }

    purchaseTank = () => {
        this.props.purchaseItem(this.state.selectedTank.id)
    }

    openCancelBetConfirmation = () => {
        this.setState({ cancelBetConfirmationOpened: true })
    }

    closeCancelBetConfirmation = () => {
        this.setState({ cancelBetConfirmationOpened: false })
    }

    handleBetChange = bet => {
        this.setState({ bet })
    }

    makeBet = () => {
        this.props.makeRewardAuctionBet(this.state.bet, this.state.selectedTank.id)
    }

    cancelBet = () => {
        this.props.cancelRewardAuctionBet()
    }

    renderCompareComponent = () => {
        if (!this.props.isAddToComparisonAvailable) return null

        return (
            <VehicleAddToComparison
                vehicleCd={this.state.selectedTank.token}
                mixClassName={styles.buttonCompare}
            />
        )
    }

    render() {
        const {
            bet,
            selectedTank,
            selectedTank: { vehicleParams },
            meta,
            anyTankSelected,
            oldCrystalBalance,
            tankPurchaseConfirmationOpened,
            cancelBetConfirmationOpened,
        } = this.state
        const {
            inHangar,
            isSelected,
            price,
            secondPrice,
        } = selectedTank

        const {
            level,
            userName,
            type,
            nation,
            vehicleId,
        } = vehicleParams

        const {
            famePoints,
        } = meta
        const { wgMoneyServiceError, accountBalance } = this.props
        const tankLevel = toRoman(level)

        const baseClassName = classnames(
            styles.base,
            (tankPurchaseConfirmationOpened || cancelBetConfirmationOpened) && styles.base__blur
        )

        const nationalityClassName = classnames(
            styles.nationality,
            styles[`nationality__${nation}`],
            isCnRealm(this.props.realm) && styles.isCnRealm,
        )
        const tankBgClassName = classnames(
            styles.tankBg,
            styles[`tankBg__${vehicleId}`],
            isCnRealm(this.props.realm) && styles.isCnRealm,
        )

        return (
            <div className={styles.baseWrapper}>
                <div className={baseClassName}>
                    <div className={styles.back}>
                        <Back handleClick={this.handleBackButtonClick}>
                            <span className={styles.backTitle}>{AFFIRMATIVE_BUTTON}</span>
                        </Back>
                    </div>
                    <div className={styles.hangarBg} />
                    <div className={tankBgClassName} />
                    <div className={styles.main}>
                        <div className={styles.wrapper}>
                            <div className={styles.header}>
                                <div className={nationalityClassName} />
                                <div className={styles.level}>{tankLevel}</div>
                                <VehicleType
                                    type={type}
                                    premium
                                    mini={false}
                                />
                                <div className={styles.name}>{userName}</div>
                                <div className={styles.compare}>
                                    {this.renderCompareComponent()}
                                    {
                                        this.props.isAddToComparisonAvailable &&
                                        <Tooltip id={VEHICLE_TO_COMPARE_TOOLTIP.id}>
                                            {VEHICLE_TO_COMPARE_TOOLTIP.message}
                                        </Tooltip>
                                    }
                                </div>
                            </div>
                            {
                                !NO_DESCRIPTION_VEHICLES.includes(this.state.selectedTank.token) &&
                                <div className={styles.info}>
                                    <div className={styles.infoIcon} />
                                    <div className={styles.infoText}>
                                        {INFO_TEXT_STYLE(STYLE_VETERAN)}
                                    </div>
                                </div>
                            }
                            <div className={styles.tankContainer}>
                                <TankInfo
                                    selectedTank={selectedTank}
                                />
                            </div>
                        </div>
                    </div>
                    <Footer
                        onCloseHandler={this.handleBackButtonClick}
                        openTankPurchaseConfirmationHandler={this.openTankPurchaseConfirmation}
                        openCancelBetConfirmationHandler={this.openCancelBetConfirmation}
                        makeBetHandler={this.makeBet}
                        handleBetChangeHandler={this.handleBetChange}
                        meta={meta}
                        bet={bet}
                        inHangar={inHangar}
                        isSelected={isSelected}
                        price={secondPrice}
                        pfpPrice={price}
                        accountBalance={accountBalance}
                        wgMoneyServiceError={wgMoneyServiceError}
                        anyTankSelected={anyTankSelected}
                    />
                </div>
                {this.state.tankPurchaseConfirmationOpened && (
                    <div className={styles.confirmWindow}>
                        <WGCWXRewardsTankConfirmation
                            title={PURCHASE_TANK(userName)}
                            buttonsOptions={[{
                                caption: PURCHASE,
                                callback: this.purchaseTank,
                            }, {
                                caption: NO,
                                callback: this.closeTankPurchaseConfirmation,
                            }]}
                            onClose={this.closeTankPurchaseConfirmation}
                        >
                            <p className={confirmationStyles.price}>
                                {CURRENCY_TO_SPEND(
                                    <span>
                                        <span className={styles.bons}>
                                            <Bons
                                                size="large"
                                                iconPosition="after"
                                                mixClassName={styles.bonds}
                                                value={secondPrice}
                                            />
                                        </span>
                                        <span className={confirmationStyles.plus} />
                                        <FamePoints size="large" value={price} />
                                    </span>
                                )}
                                <span className={confirmationStyles.price_divider} />
                                {CURRENCY_LEFT(
                                    <span>
                                        <span className={styles.bons}>
                                            <Bons
                                                size="large"
                                                iconPosition="after"
                                                mixClassName={styles.bonds}
                                                value={oldCrystalBalance - secondPrice}
                                            />
                                        </span>
                                        <span className={confirmationStyles.plus} />
                                        <FamePoints size="large" value={famePoints - price} />
                                    </span>
                                )}
                            </p>
                        </WGCWXRewardsTankConfirmation>
                    </div>
                )}

                {this.state.cancelBetConfirmationOpened && (
                    <div className={styles.confirmWindow}>
                        <WGCWXRewardsTankConfirmation
                            buttonsOptions={[{
                                caption: CANCEL_BET,
                                callback: this.cancelBet,
                            }, {
                                caption: NO,
                                callback: this.closeCancelBetConfirmation,
                            }]}
                            messageType="alert"
                            title={CANCEL_BET_TITLE}
                            description={CANCEL_BET_DESCRIPTION}
                            onClose={this.closeCancelBetConfirmation}
                        />
                    </div>
                )}
            </div>
        )
    }
}

WGCWXRewardsTank.propTypes = {
    rewardsMeta: RewardsMetaPropTypes,
    backToRewardsHandler: PropTypes.func.isRequired,
    purchaseItem: PropTypes.func.isRequired,
    makeRewardAuctionBet: PropTypes.func.isRequired,
    cancelRewardAuctionBet: PropTypes.func.isRequired,
    selectedTank: PropTypes.arrayOf(RewardPropTypes),
    wgMoneyServiceError: PropTypes.bool.isRequired,
    isAddToComparisonAvailable: PropTypes.bool.isRequired,
    accountBalance: BalancePropTypes,
    anyTankSelected: PropTypes.bool.isRequired,
    realm: PropTypes.string.isRequired,
}

const mapStateToProps = state => {
    return {
        realm: state.settings.realm,
    }
}

export default connect(mapStateToProps)(WGCWXRewardsTank)



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/WGCWXRewardsTank.jsx